import moment from "moment";
import { default as api } from "../../api";
import { weekFormat, hasOwnProperty, nl2br, isDateBetween, expectStyleTag } from "../../utils/lib";

const keepMiddleware = (item, id, next) => {
    const newItem = item.reduce((prev, c) => {
        let current = c;
        if (hasOwnProperty(c, "articleIdx") && c.articleIdx === id) {
            current.isKeeped = next;
        }

        return [...prev, current];
    }, []);

    return newItem;
};

export const mutations = {
    SET_PAGE(state, payload) {
        const { type, page } = payload;
        state.pages[type] = page;
        // state.page = payload;
    },

    SET_IS_LAST(state) {
        state.isLast = true;
        state.isNoneSubscribe = false;
    },

    SET_IS_NONE_SUBSCRIBE(state, payload) {
        state.isNoneSubscribe = payload;
    },

    SET_SHARE_TOGGLE(state) {
        state.share.toggle = !state.share.toggle;
    },

    SET_SHARE_URL(state, payload) {
        state.share.toggle = true;
        state.share.url = payload;
    },

    SET_CLEAR(state, payload) {
        state.isLast = false;
        state.isNoneSubscribe = false;
    },

    SET_FIXED_SCROLL(state, payload) {
        const { type, scroll } = payload;
        state.fixedScroll[type] = scroll;
    },

    SET_ALL_CLEAR(state) {
        state.newsfeed = [];
        state.notice = [];
        state.community = [];
        state.mill = [];
        state.like = [];

        state.isLast = false;
    },

    SET_NEWSFEED(state, payload) {
        const { type, data } = payload;

        const now = new Date(moment().format("YYYY/MM/DD")).getTime();
        const { pages } = state;

        const todos = data.feedList
            .map(({ itemType, postDate, boardName, ...rest }) => {
                if (itemType === 3) return null;

                let file = [],
                    image = [],
                    type = "notice";

                if (hasOwnProperty(rest, "file")) {
                    file = rest.file;
                }

                const between = isDateBetween(now, postDate);
                const posted_at = between || weekFormat(moment(postDate).format("|E요일 YYYY년 MM월 DD일"));
                const html = expectStyleTag(rest.content);

                return {
                    ...rest,
                    content: html,
                    file,
                    image,
                    boardName,
                    type: state.typeIcon[boardName] || type,
                    posted_at
                };
            })
            .filter(v => v !== null);

        // 중복 렌더링 방지
        if (pages[type] === 1) {
            state[type] = todos;
            return;
        }

        state[type] = [...state[type], ...todos];
    },

    SET_LOADING(state, payload) {
        state.loading[payload] = !state.loading[payload];
    },

    SET_DO_KEEPING(state, payload) {
        const { articleIdx, next, type } = payload;

        // 현재 페이지
        const todos = state[type];
        const newTodos = keepMiddleware(todos, articleIdx, next);
        state[type] = newTodos;
        // --- 현재 페이지

        if (type === "newsfeed" || type === "like") {
            const newItem = state[type].find(_ => _.articleIdx === articleIdx);
            const _type = hasOwnProperty(newItem, "type") && newItem.type === "airplain" ? "community" : newItem.type;

            // like 나 newsfeed 에서 누르면 다른 게시물에서도 '담아두기'가 없어져야하기 때문에 아래 작업을 해준다.
            state[_type] = state[_type].reduce((prev, c) => {
                let current = c;
                if (c.articleIdx === articleIdx) {
                    current.isKeeped = next;
                }

                return [...prev, current];
            }, []);
        }

        if (type !== "newsfeed") {
            // newsfeed 연동
            const newNewsFeed = keepMiddleware(state.newsfeed, articleIdx, next);
            state.newsfeed = newNewsFeed;
        }

        // like 연동
        const isAlreadyExist = state.like.findIndex(_ => _.articleIdx === articleIdx) !== -1;

        if (isAlreadyExist) {
            // like에 이미 아이템이 있는 경우 해당 아이템을 삭제한다.
            state.like = state.like.filter(_ => _.articleIdx !== articleIdx);
        } else {
            const newItem = state[type].find(_ => _.articleIdx === articleIdx);
            const ready = [newItem, ...state.like];

            const sortItem = ready.sort((a, b) => {
                const aid = parseInt(a.articleIdx);
                const bid = parseInt(b.articleIdx);

                return aid < bid ? 1 : -1;
            });

            state.like = sortItem;
        }
    }
};

export const actions = {
    async GET_NEWS_FEED({ state, commit, rootState }, { $alert, type }) {
        // notice

        commit("SET_LOADING", [type]);

        const { token } = rootState.user;
        const { pages } = state;

        const params = {
            token,
            page: pages[type],
            getTypeId: "newsfeed"
        };

        // 일반 전역 게시판 path = /
        if (type === "newsfeed") {
            params.feedType = null;
        }

        if (type === "notice") {
            params.feedType = 0;
        }

        if (type === "community") {
            params.feedType = 1;
        }

        if (type === "mill") {
            params.feedType = 2;
        }

        if (type === "like") {
            params.getTypeId = "keeping";
        }

        try {
            const response = await api.notice.getNewsfeed(params);

            if (response.data.resultCode === 10003) {
                commit("SET_IS_LAST");
            } else if (response.data.resultCode === 10005) {
                // 구독중이 학교가 없는 건 여기서 NEWS_FEED 에서 밖에 알수가 없음.
                // getSchoolList 에서도 알 수는 있지만 10003 으로 유니크 하지 않음
                commit("SET_ALL_CLEAR");
                commit("SET_IS_NONE_SUBSCRIBE", true);
            } else {
                commit("SET_IS_NONE_SUBSCRIBE", false);
                commit("SET_NEWSFEED", { data: response.data, type });
            }

            commit("SET_LOADING", type);
        } catch (e) {
            commit("SET_LOADING", type);
            $alert("error", e.message);
        }
    }
};
